<template>
    <div class="row">
        <div class="col-12">

            <!-- Desktop -->
            <div class="d-none d-md-flex align-items-center overflow-auto bg-light rounded p-1 shadow-sm">
                <div
                    v-for="(item, index) in tabs"
                    :key="index"
                    :class="['px-3 py-2 rounded cursor-pointer text-nowrap', item.id == value ? 'text-info bg-white shadow-lg fade-in' : 'text-muted']"
                    v-on:click="$emit('input', item.id)"
                >
                    <i :class="['mdi mr-1', item.icon]"></i>
                    {{ item.name }}
                    <div
                        v-if="item.count"
                        :class="[
                            'ml-1',
                            'badge',
                            item.id == value ? 'badge-info' : 'badge-secondary',
                        ]"
                    >
                        {{ item.count }}
                    </div>
                </div>
            </div>

            <!-- Mobile -->
            <b-dropdown
                class="d-md-none"
                variant="light"
                block
                no-caret
                menu-class="w-100"
            >
                <template #button-content>
                    <div class="d-flex align-items-center">
                        <i class="mdi mdi-menu mr-2"></i>
                        <span>{{ activeTabItem ? activeTabItem.name : '' }}</span>
                        <span
                            v-if="activeTabItem && activeTabItem.count"
                            class="ml-1 badge badge-info"
                        >
                            {{ activeTabItem.count }}
                        </span>
                        <i class="mdi mdi-chevron-down ml-auto"></i>
                    </div>
                </template>
                <b-dropdown-item
                    v-for="(item, index) in tabs"
                    :key="index"
                    v-on:click="$emit('input', item.id)"
                >
                    <i :class="['mdi mr-2', item.icon, item.id == value ? 'text-info' : 'text-muted']"></i>
                    <span :class="item.id == value ? 'text-info font-weight-bold' : ''">
                        {{ item.name }}
                    </span>
                    <span
                        v-if="item.count"
                        :class="[
                            'ml-1',
                            'badge',
                            item.id == value ? 'badge-info' : 'badge-secondary',
                        ]"
                    >
                        {{ item.count }}
                    </span>
                </b-dropdown-item>
            </b-dropdown>

        </div>
    </div>
</template>
<script>
export default {
    props: {
        tabs: {
            type: Array,
            required: true,
        },
        value: {
            type: [Number, String],
            required: false,
        },
    },
    computed: {
        activeTabItem() {
            return this.tabs.find(item => item.id == this.value);
        },
    },
};
</script>